import React from 'react';
import OfferingsSection from '../../components/OfferingsSection';
import HeroBanner from '../../components/HeroBanner';
import WelcomeSection from '../../components/WelcomeSection';
import WhoWeAreSection from '../../components/WhoWeAreSection';
import './HomePage.css';

const HomePage = () => {
  return (
    <div className="home-page">
      <OfferingsSection />
      <HeroBanner />
      <WelcomeSection />
      <WhoWeAreSection />
    </div>
  );
};

export default HomePage;
